import { Column, Columns, Inline, Stack } from '@superdispatch/ui';
import {
  FormikCheckboxArrayField,
  FormikCheckboxArrayGroup,
} from 'shared/form/FormikCheckboxArrayGroup';
import { DriverPreferencesErrorMessage } from './DriverPreferencesErrorMessage';

interface DriverPreferencesListItemProps {
  name: string;
  label: string;
  icon: React.ReactNode;
}

interface DriverPreferencesCheckboxListProps {
  items: DriverPreferencesListItemProps[];
  groupName: string;
  errorMessage: string;
}

function DriverPreferencesCheckboxListItem({
  name,
  label,
  icon,
}: DriverPreferencesListItemProps) {
  return (
    <label>
      <Columns align="center">
        <Column>
          <Inline verticalAlign="center">
            {icon}
            {label}
          </Inline>
        </Column>
        <Column width="content">
          <FormikCheckboxArrayField name={name} label="" />
        </Column>
      </Columns>
    </label>
  );
}

export function DriverPreferencesCheckboxList({
  items,
  groupName,
  errorMessage,
}: DriverPreferencesCheckboxListProps) {
  return (
    <FormikCheckboxArrayGroup name={groupName}>
      <Stack space="medium" aria-label={groupName}>
        {items.map(({ name, label, icon }) => (
          <DriverPreferencesCheckboxListItem
            key={name}
            name={name}
            label={label}
            icon={icon}
          />
        ))}
        {!!errorMessage && (
          <DriverPreferencesErrorMessage errorMessage={errorMessage} />
        )}
      </Stack>
    </FormikCheckboxArrayGroup>
  );
}
